import React from 'react';
import './testi.css';
import citi from '../../assets/citi-logo 1.png'
import pngtree from '../../assets/Pngtree.png'
import cat from '../../assets/cat.png'
import nescafe from '../../assets/nescafe.png'
import playboy from '../../assets/Playboy.png'
import avatar from '../../assets/avatar.png';
import AboutComp from "../about/about";
import ServiceComp from "../services/serivicesComp"
import { Swiper, SwiperSlide} from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y  } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar'

const Testi = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
 return(
    <div className='Testimonial'>
        {/*<section className="favdoc__testi">
            <article className='favdoc__testi-container'>
                <div>
                    <h2>20</h2>
                    <p>Registered Hospitals</p>
                </div>
                <div>
                    <h2>2500</h2>
                    <p>Diagnosed Patients</p>
                </div>
                <div>
                    <h2>1500</h2>
                    <p>Total Registered Users</p>
                </div>
                <div>
                <h2>20</h2>
                <p>Total Phamarcy Registered</p>
            </div>
            </article>
 </section>*/}
        <AboutComp />
        <ServiceComp />
        <section className='favdoc__testi_two'>
            <h3>In our patients words</h3>
            <div className="slider" style={{height: "fit-content"}}>
            <Swiper
            // install Swiper modules
            modules={[Navigation, Pagination, A11y]}
            spaceBetween={50}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log('slide change')}
            style={{height: 100 + '%'}}>
                    <SwiperSlide><Card src='../../assets/Rectangle 310.png'/></SwiperSlide> 
                    <SwiperSlide><Card src='../../assets/Rectangle 310.png' alt=""/></SwiperSlide> 
                    <SwiperSlide><Card src='../../assets/Rectangle 310.png' alt=""/></SwiperSlide> 
                </Swiper>
            </div>
        </section>
        <section className='favdoc__testi_three'>
            <h3>We Are Trusted By</h3>
            <article className='favdoc__testi_img_container'>
                 <div className='fav__testi-img'>
                     <img src={citi} alt='FavDoctor-Partners' />
                 </div>
                 <div className='fav__testi-img'>
                     <img src={pngtree} alt='FavDoctor-Partners' />
                 </div>
                 <div className='fav__testi-img'>
                     <img src={cat} alt='FavDoctor-Partners' />
                 </div>
                 <div className='fav__testi-img'>
                     <img src={nescafe} alt='FavDoctor-Partners' />
                 </div>
                 <div className='fav__testi-img'>
                     <img src={playboy} alt='FavDoctor-Partners' />
                 </div>
            <div className='favdoc__testi_image_container_'>
            <div className='fav__testi-img'>
                    <img src={citi} alt='FavDoctor-Partners'/>
                </div>
                <div className='fav__testi-img'>
                    <img src={pngtree} alt='FavDoctor-Partners'/>
                </div>
                <div className='fav__testi-img'>
                    <img src={cat} alt='FavDoctor-Partners'/>
                </div>
            </div>
           <div className='favdoc__testi_image_container_'>
           <div className='fav__testi-img'>
           <img src={nescafe} alt='FavDoctor-Partners'/>
       </div>
       <div className='fav__testi-img'>
           <img src={playboy} alt='FavDoctor-Partners'/>
       </div>
           </div>
               
            </article>
        </section>
    </div>
 )
};

const Card = () =>{
    return(
        <div className="card" style={{display: 'flex', alignItems: 'center', flexDirection:'column', textAlign: 'center'}}>
            <img src={avatar} alt="favDoctor-avatar" style={{width:120, height:120}} />
            <p>The doctor's guidance and prompt responses gave me reassurance and peace of mind. I followed their recommendations, and gradually, my health improved. The FavDoctor app not only saved me money but also helped me regain my health without compromising on the quality of care I received.</p>
        </div>
    )
}

export default Testi